import ManoeuvreElectrique from 'assets/img/manoeuvre-electrique.png';
import ManoeuvreManuel from 'assets/img/manoeuvre-manuel.png';
import formInputsTypes, {
    createAxe,
    LameColor,
    LameTaille,

} from '../simulatorConstant';
import { MesureLargeur } from '../rideauMetallique/data';
import ManivelleDroite from 'assets/img/manivelle-droite.png';
import ManivelleGauche from 'assets/img/manivelle-gauche.png';

import ManoeuvreManuelZingle from 'assets/img/manoeuvre-manuel-zingle.png';

const cote_manivelle = {
    id: 'cote_manivelle',
    type: formInputsTypes?.RADIO_INPUT,
    label: 'Côté de manœuvre',
    name: 'cote_manivelle',
    className: 'col-6',
    nextStepData: false,
    nextStep: false,

    fetchData: (currentFormValue, fnSuccess) => {
        const type = currentFormValue?.values?.manoeuvreManuel?.value;

        const options = [

            {
                id: 'GM',
                label: 'Gauche',
                value: 'gauche',
                imageUrl: ManivelleGauche,
                description:
                    `- Manœuvre par ${type} positionnée à gauche (vue intérieure).`,

                nextStep: false,
            },
            {
                id: 'DM',
                label: 'Droite',
                value: 'droite',
                imageUrl: ManivelleDroite,
                description:
                    `- Manœuvre par ${type} positionnée à droite (vue intérieure).`,
                nextStep: false,
            },
        ]
        fnSuccess(options);
    },
};

const manoeuvreManuel = {
    id: 'manoeuvreManuel',
    type: formInputsTypes?.SELECT_INPUT,
    label: 'Type de manœuvre manuelle',
    name: 'manoeuvreManuel',
    nextStepData: cote_manivelle,
    nextStep: false,
    options: [
        {
            id: 'Manivelle',
            label: 'Manivelle',
            value: 'Manivelle',
            checked: true,
            imageUrl: ManoeuvreManuel,

        },
        {
            id: 'Sangle ZF',
            label: 'Sangle ZF',
            value: 'Sangle ZF',
            checked: false,
            imageUrl: ManoeuvreManuelZingle,

        },
    ],
};


const coulisse = {
    id: 'VR-TR-TB-CLIS',
    type: formInputsTypes?.RADIO_INPUT,
    name: 'coulisse',
    className: 'col-6',
    label: 'Avec Coulisse',
    defaultValue: 0,
    nextStepData: false,
    nextStep: false,
    options: [
        {
            id: 'with-coulisse',
            label: 'Oui',
            value: 'oui',
            checked: true,
            nextStep: LameColor(createAxe(manoeuvreManuel), 'Couleur de coulisse'),
            description: '- Avec Coulisse',
        },
        {
            id: 'without-coulisse',
            label: 'Non',
            value: 'non',
            checked: false,
            nextStep: createAxe(manoeuvreManuel),
            description: '- Sans Coulisse',
        },
    ],
};



const TypeMesureHaut = {
    id: 'VR-TR-VRC-TMH',
    type: formInputsTypes?.RADIO_INPUT,
    name: 'typeMesureHauteur',
    className: 'col-6',
    label: 'Mesure selon hauteur',
    nextStepData: LameTaille(
        LameColor(createAxe(manoeuvreManuel), 'Couleur de lame'),
    ),
    nextStep: false,
    fetchData: (currentFormValue, fnSuccess) => {
        const hauteur = currentFormValue?.values?.hauteur?.value;

        const options = [
            {
                id: 'RMFN',
                label: 'FINI',
                value: 'FINI',
                nextStep: false,
                description: `- Hauteur : ${hauteur} mm FINI`

            },
            {
                id: '+E',
                label: '+E',
                value: '+E',
                nextStep: false,
                description: `- Hauteur : ${hauteur} mm +E`


            },

        ]
        fnSuccess(options);
    },
};

const hieghtTablier = {
    id: 'VR-TR-VRC-H',
    type: formInputsTypes?.INPUT_NUMBER,
    name: 'hauteur',
    className: 'col-6',
    label: 'Hauteur entre murs (mm)',
    defaultValue: 0,
    nextStepData: TypeMesureHaut,
    nextStep: false,
    notIncludeDescription: true,
    validation: (value) => {
        return value > 0;
    },
};
const typeMesureLargeur = {
    id: 'VR-TR-VRC-TMW',
    type: formInputsTypes?.RADIO_INPUT,
    name: 'typeMesureLargeur',
    className: 'col-6',
    label: 'Mesure selon largeur',
    nextStepData: hieghtTablier,
    nextStep: false,
    fetchData: (currentFormValue, fnSuccess) => {
        const largeur = currentFormValue?.values?.largeur?.value;

        const options = [
            {
                id: 'RMFN',
                label: 'FINI',
                value: 'FINI',
                nextStep: false,
                description: `- Largeur : ${largeur} mm FINI`

            },
            {
                id: 'RME',
                label: 'DC',
                value: 'DC',
                nextStep: false,
                description: `- Largeur : ${largeur} mm D.C`


            },

        ]
        fnSuccess(options);
    },
};

const CompletManuel = {
    id: 'VR-TR-VRC-W',
    type: formInputsTypes?.INPUT_NUMBER,
    name: 'largeur',
    className: 'col-6',
    label: 'Largeur entre murs (mm)',
    placeholder: '0',
    defaultValue: 0,
    nextStepData: typeMesureLargeur,
    notIncludeDescription: true,
    nextStep: false,
    validation: (value) => {
        return value > 0;
    },
};

export default CompletManuel;
